interface ServiceVisualProps {
  title: string;
  subtitle: string;
  bars: { label: string; value: number; color: string }[];
}

export default function ServiceVisual({ title, subtitle, bars }: ServiceVisualProps) {
  return (
    <div className="rounded-[30px] border border-[#171717]/10 bg-white/86 p-6 shadow-[0_18px_50px_rgba(23,23,23,0.05)]">
      <p className="text-[10px] uppercase tracking-[0.22em] text-[#6b6b6b] font-bold mb-3">Where the system is strongest, and where it still leaks</p>
      <h3 className="text-2xl font-black tracking-[-0.04em] mb-2">{title}</h3>
      <p className="text-sm text-[#4f4f4f] leading-relaxed mb-5">{subtitle}</p>
      <div className="space-y-4">
        {bars.map((bar) => (
          <div key={bar.label}>
            <div className="flex items-center justify-between text-sm mb-1.5">
              <span className="text-[#4f4f4f]">{bar.label}</span>
              <span className="font-bold text-[#171717]">{bar.value}%</span>
            </div>
            <div className="h-3 rounded-full bg-[#171717]/8 overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${bar.value}%`, backgroundColor: bar.color }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
